import { addReaction, getAllPosts, getAllUserPosts, getPostsByTag } from '../../api/post';
import {toastr} from "react-redux-toastr";

export function getPostSuccess(payload) {
    return {
        type: 'GET_POST_SUCCESS',
        payload,
    }
};



export function addPostSuccess(payload) {
    return {
        type: 'ADD_POST_SUCCESS',
        payload,
    }
};

export function deletePostSuccess(payload) {
    return {
        type: 'DELETE_POST_SUCCESS',
        payload,
    }
};

export function sharePostSuccess(payload) {
    return {
        type: 'SHARE_POST_SUCCESS',
        payload,
    }
};

export function resetExistingPosts() {
    return {
        type: 'RESET_EXISTING_POSTS'
    }
};

export function likePostStart() {
    return {
        type: 'LIKE_POST_START'
    }
};

export function likePostSuccess(payload) {
    return {
        type: 'LIKE_POST_SUCCESS',
        payload,
    }
};

export function likePostFailure(payload) {
    return {
        type: 'LIKE_POST_FAILURE',
        payload,
    }
};


export function getTaggedPostSuccess(payload) {
    return {
        type: 'GET_TAGGED_POST_SUCCESS',
        payload,
    }
};

export const getPosts = (data) => async dispatch => {

    try {
        const response = await getAllPosts(data);

        if (Object.keys(response).length) {

            dispatch(getPostSuccess(response));
        }
    } catch (e) {
        toastr.error("Sorry!", "Something went wrong with newsfeed");
        return [];
    }
};

export const getPostsFromTag = (tagId) => async dispatch => {
    try {
        const response = await getPostsByTag(tagId);
        dispatch(resetExistingPosts());
        if (Object.keys(response).length) {
            dispatch(getTaggedPostSuccess(response));
        }
    } catch (e) {
        toastr.error("Sorry!", "Something went wrong with post");
        return [];
    }
};

export const getUserSpecificPosts = (data) => async dispatch => {
    try {
        const response = await getAllUserPosts(data);
        if (Object.keys(response).length) {
            dispatch(getPostSuccess(response));
        }
    } catch (e) {
        toastr.error("Sorry!", "Something went wrong with newsfeed");
        return [];
    }
};


export const likePost = (data) => async dispatch => {
    try {
        let response = await addReaction(data);
        if (Object.keys(response).length) {
            response = Object.assign(data,response);
            // dispatch(likePostSuccess(response));
        }
    } catch (e) {
        toastr.error("Sorry!", "Not able to perform operation.");
        return {};
    }
};

export function addPostViaSocket(payload) {
    return {
        type: 'ADD_POST_SOCKET',
        payload,
    }
};

export function addSinglePost(payload) {
    return {
        type: 'ADD_SINGLE_POST',
        payload,
    }
};

export function deletePostViaSocket(payload) {
    return {
        type: 'DELETE_POST_SOCKET',
        payload,
    }
};

export function sharePostViaSocket(payload) {
    return {
        type: 'SHARE_POST_SOCKET',
        payload,
    }
};
